import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { useAlert } from 'react-alert';
import AuthContext from '../../authentication/AuthContext';
import UserContext from '../../user/UserContext';
import LoadingSpinner from '../../common/LoadingSpinner';
import WebDealCard from './web-deal-card/WebDealCard';
import styles from './webDeals.module.scss';

export default function WebDeals() {
    const cas = useContext(AuthContext);
    const { userDetails } = useContext(UserContext);

    const [loading, setLoading] = useState(true);
    const [deals, setDeals] = useState();
    const alert = useAlert();

    useEffect(() => {
        getWebDeals();
        // eslint-disable-next-line
    }, [cas, userDetails]);

    const getWebDeals = () => {
        if (userDetails.currentFranchise) {
            setLoading(true);
            axios
                .get(
                    window.CONFIG['ws.activoc-web-deals-public.headers.summary'].replace(
                        '{franchiseCode}',
                        userDetails.currentFranchise.code
                    ),
                    {
                        headers: {
                            Authorization: cas,
                            'Content-Type': 'application/json'
                        }
                    }
                )
                .then(response => {
                    const json = response.data;
                    setLoading(false);

                    if (json.length > 0) {
                        setDeals(json.map(deal => <WebDealCard deal={deal} key={deal.id} />));
                    } else {
                        setDeals(<div>No Deals Available</div>);
                        alert.info('No Deals Available.');
                    }
                })
                .catch(() => {
                    setLoading(false);
                    setDeals(<div>Error Retrieving Deals</div>);
                    alert.error('ERROR: Unable to retrieve deals.');
                });
        }
    };

    return (
        <>
            <div className={'page-header'}>
                <div className={'content'}>
                    <div className={'page-header-container'}>
                        <h1>My Web Deals</h1>
                    </div>
                </div>
            </div>
            <div className={`content ${styles.webDealCards}`}>{loading ? <LoadingSpinner /> : deals}</div>
        </>
    );
}
